export type ProjectSort = 'opened-desc' | 'asc' | 'desc';
export interface ProjectSortPreference {
  read(): ProjectSort;
  write(value: ProjectSort): void;
}
const key = 'digitiles.projects.sort.v1';
export const projectSortPreference: ProjectSortPreference = {
  read() {
    try {
      const value = localStorage.getItem(key);
      return value === 'asc' || value === 'desc' ? value : 'opened-desc';
    } catch {
      return 'opened-desc';
    }
  },
  write(value) {
    try {
      localStorage.setItem(key, value);
    } catch {
      // The current chooser remains usable without persisted preferences.
    }
  },
};
